import apiClient from './client';

export interface News {
  _id: string;
  title: string;
  slug: string;
  content: string;
  excerpt?: string;
  coverImage?: string;
  tags: string[];
  author: {
    firstName: string;
    lastName: string;
    avatar?: string;
  };
  isPublished: boolean;
  publishedAt?: string;
  views: number;
  createdAt: string;
}

export interface CreateNewsDto {
  title: string;
  content: string;
  excerpt?: string;
  coverImage?: string;
  tags?: string[];
  isPublished?: boolean;
}

export const newsApi = {
  getAll: async (): Promise<News[]> => {
    const response = await apiClient.get('/news');
    return response.data;
  },

  getBySlug: async (slug: string): Promise<News> => {
    const response = await apiClient.get(`/news/slug/${slug}`);
    return response.data;
  },

  getById: async (id: string): Promise<News> => {
    const response = await apiClient.get(`/news/${id}`);
    return response.data;
  },

  create: async (data: CreateNewsDto): Promise<News> => {
    const response = await apiClient.post('/news', data);
    return response.data;
  },

  update: async (id: string, data: Partial<CreateNewsDto>): Promise<News> => {
    const response = await apiClient.put(`/news/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/news/${id}`);
  },
};
